var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#84DB8A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 46,
    cy: 46,
    r: 38,
    fill: "#84DB8A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 30,
    fill: "#84DB8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.926 35.9398C62.3947 36.4086 62.658 37.0444 62.658 37.7073C62.658 38.3702 62.3947 39.006 61.926 39.4748L43.1877 58.2132C42.94 58.4609 42.646 58.6573 42.3225 58.7914C41.9989 58.9254 41.6521 58.9944 41.3018 58.9944C40.9516 58.9944 40.6048 58.9254 40.2812 58.7914C39.9576 58.6573 39.6636 58.4609 39.416 58.2132L30.106 48.9048C29.8672 48.6742 29.6768 48.3984 29.5457 48.0933C29.4147 47.7883 29.3458 47.4603 29.3429 47.1283C29.34 46.7964 29.4032 46.4672 29.5289 46.1599C29.6546 45.8527 29.8403 45.5736 30.075 45.3388C30.3097 45.1041 30.5889 44.9185 30.8961 44.7928C31.2033 44.6671 31.5325 44.6038 31.8645 44.6067C32.1964 44.6096 32.5245 44.6786 32.8295 44.8096C33.1345 44.9406 33.4104 45.1311 33.641 45.3698L41.301 53.0298L58.3893 35.9398C58.6215 35.7075 58.8972 35.5232 59.2006 35.3975C59.504 35.2717 59.8292 35.207 60.1577 35.207C60.4861 35.207 60.8113 35.2717 61.1147 35.3975C61.4182 35.5232 61.6938 35.7075 61.926 35.9398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e3cd98c82da9111d29b9ffd3985119a4.svg";
export { ForwardRef as ReactComponent };